import request from '@/utils/request'

export function getAllRegisters() {
  return request({
    url: '/sabtenamedoreha/get',
    method: 'post'
  })
}


export function saveSabtenam(doreID) {
  return request({
    url: '/sabtenamedoreha/register',
    method: 'post',
    data: { doreID: doreID }
  })
}


export function getSabtenamHistory() {
  return request({
    url: '/sabtenamedoreha/gethistory',
    method: 'post'
  })
}

export function downloadMadrak(RegisterID) {
  return request({
    url: '/sabtenamedoreha/downloadmadrak',
    method: 'post',
    
    data: { RegisterID: RegisterID }
  })

}







